import { InputBaseComponentProps } from '@mui/material/InputBase';
import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { RefCallback, forwardRef } from 'react';
import MaskedInput from 'react-text-mask';
import { Mask } from 'react-text-mask/index';

const CustomTextMask = forwardRef(({ mask, ...props }: InputBaseComponentProps, inputRef) => (
  <MaskedInput
    {...props}
    ref={(ref) => {
      (inputRef as RefCallback<any>)?.(ref ? ref.inputElement : null);
    }}
    mask={mask}
  />
));

export type MaskedFieldProps = TextFieldProps & {
  mask: Mask | ((value: string) => Mask);
  fullWidth?: boolean;
  variant?: 'filled' | 'outlined' | 'standard';
};

/** @deprecated Use `components/v2/form/MaskField` instead. */
const MaskedField = forwardRef<any, MaskedFieldProps>(function MaskedField(
  { fullWidth = false, mask, slotProps, variant = 'outlined', ...props },
  ref,
) {
  return (
    <TextField
      variant={variant}
      fullWidth={fullWidth}
      inputRef={ref}
      {...props}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          inputComponent: CustomTextMask,
        } as OutlinedInputProps,
        htmlInput: { mask, ...slotProps?.htmlInput },
      }}
    />
  );
});

export default MaskedField;
